import * as loaders from "loaders/legacy/legacy-bvhFileLoader";
export { loaders };
export default loaders;
